import React, { useState } from "react"

import PropTypes from "prop-types"

import "./index.less"

import { Button, Modal, Select } from "antd"
import { uuid, validate } from "../../utils/functions"

const { Option } = Select

export function ModalImportActionPlans(props) {
  const [idMeasure, setMeasure] = useState(null)

  const handleChange = (value) => setMeasure(value)
  const styleOk = validate.exist(idMeasure)
    ? {}
    : { backgroundColor: "#C4C4C4", borderColor: "#C4C4C4", color: "#FFFFFF" }
  return (
    <Modal
      title="Importar planes de acción"
      className="ModalImportActionPlans"
      visible={props.isModalVisible}
      width={540}
      onOk={() => props.handleOk(idMeasure)}
      onCancel={() => props.handleCancel()}
      footer={[
        <Button
          key="back"
          onClick={() => {
            setMeasure(null)
            props.handleCancel()
          }}>
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          style={styleOk}
          disabled={!validate.exist(idMeasure)}
          onClick={() => props.handleOk(idMeasure)}>
          Aceptar
        </Button>,
      ]}>
      <div className="ModalImportActionPlans--content">
        <div className="ModalImportActionPlans--content-title">
          Selecciona la medición para la cual se importarán los planes:
        </div>
        <div className="ModalImportActionPlans--content-select">
          <Select
            value={idMeasure}
            placeholder="Seleccionar medición"
            style={{ width: 296 }}
            onChange={handleChange}>
            {props.measuresList.map((item) => {
              return (
                <Option key={uuid()} value={item.id_measure}>
                  {item.name}
                </Option>
              )
            })}
          </Select>
        </div>
      </div>
    </Modal>
  )
}

ModalImportActionPlans.propTypes = {
  isModalVisible: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleOk: PropTypes.func,
  measuresList: PropTypes.array,
}
export default ModalImportActionPlans
